import { useRecoilState } from 'recoil';

import {
	ActivePaymentType,
	PaymentNavigationState,
} from 'views/settings/billing/stores';

export const useChoose = () => {
	const [choose, setChoose] = useRecoilState(ActivePaymentType);
	const [addPaymentNaviagtion, setAddPaymentNaviagtion] = useRecoilState(
		PaymentNavigationState
	);

	/*
	 * WIRE IS NOT SPECIAL-CASED HERE ANY MORE.
	 *
	 * Both of these used to `return` early on Wire, which — together with the
	 * unconditional `pointer-events: none` on the wire tile — made the option
	 * unreachable by any route. The rest of the flow was never missing:
	 * `use-payments.ts` routes `WireScreen` to `handleWireAccount()` and
	 * `components/wire-page/wire.tsx` renders the instructions. So the feature
	 * was built, shipped and then blocked at the first click.
	 *
	 * If wire ever does need gating, it belongs on the tile as data (the
	 * `disabled` flag the picker already reads) with a reason the user can see,
	 * not as a silent no-op in a handler.
	 */
	const handleChoose = (val: string) => () => {
		setChoose(val);
	};

	const handleChooseNavigate = (val: string) => () => {
		setAddPaymentNaviagtion(val);
		setChoose(val);
	};

	return {
		choose,
		handleChoose,
		addPaymentNaviagtion,
		handleChooseNavigate,
	};
};
